<template>
  <div class="jobs-list" v-loading="loader">
    <div class="flex-1 flex-end">
      <ImportWorks @update="updateJobs" v-if="$route.query.dir"/>

      <ImportLineFromFile v-if="$route.params.type === 'line'" @update="fetchJobs" />
    </div>
    <el-input placeholder="Поиск ..." v-model="search" class="input-search">
      <el-button slot="append" icon="el-icon-search"></el-button>
    </el-input>
    <draggable
      class="jobs-ul"
      handle=".handle"
      :list="works" @change="save"
    >
      <router-link
        :to="`/dashboard/works/edit/${work.id}/${$route.params.type || 'job'}?t=t${$route.query.dir ? `&dir=${$route.query.dir}` : ''}${$route.query.version ? '&version=' + $route.query.version + '&name=' + $route.query.name: ''}`"
        class="jobs-li" v-for="(work, index) in filteredList" :key="index"
      >
        <div class="name handle">
          <i class="fa fa-align-justify"></i>
          <span>{{ work.name }}</span>
        </div>
        <div>

          <i class="fa fa-edit"></i>
        </div>
      </router-link>
    </draggable>
    <router-link :to="`/dashboard/works/create/${$route.params.type || 'job'}${$route.query.dir ? `?dir=${$route.query.dir}` : ''}${$route.query.version ? '?version=' + $route.query.version + '&name=' + $route.query.name: ''}`" class="add-job">
      <el-button>+ Добавить</el-button>
    </router-link>
  </div>
</template>

<script>
import firebase from 'firebase';
import _ from 'lodash';
import draggable from 'vuedraggable';
import ImportWorks from "./ImportWorks";
import ImportLineFromFile from "./ImportLineFromFile";

export default {
  name: 'List',
  components: {ImportLineFromFile, ImportWorks, draggable},

  data() {
    return {
      loader: false,
      search: '',
      works: [],
    };
  },

  mounted() {
    this.fetchJobs();
  },

  methods: {
    fire() {
      if(this.$route.query.version) {
        return firebase.firestore()
          .collection('projects')
          .doc(this.$store.state.project.id)
          .collection('versions')
          .doc(this.$route.query.version)
      }

      return firebase.firestore()
        .collection('projects')
        .doc(this.$store.state.project.id)
    },
    updateJobs() {
      this.fetchJobs();
    },
    save: _.debounce(function (el, binding) {
      const works = this.works.map((work, index) => {
        return {
          ...work,
          _data: {
            ...work._data,
            index: index,
          },
        };
      });

      this.update(works);
    }, 1000),
    update(works) {
      let batch = firebase.firestore().batch();
      works.forEach((doc) => {
        const docRef = this.fire()
          .collection('works_type')
          .doc(doc.id);
        batch.update(docRef, doc._data);
      });
      batch.commit();
    },
    deleteObject(id) {
      this.$confirm('Вы действительно хотите удалить?', 'Подтверждение', {
        confirmButtonText: 'Да',
        cancelButtonText: 'Нет',
        type: 'warning',
      }).then(() => {
        this.fire()
          .collection('works_type')
          .doc(id).delete()
          .then((data) => {
            this.$emit('update');
            this.fetchJobs();
            this.$notify({
              offset: 60,
              title: 'Успешно!',
              message: 'удалено',
              type: 'success',
            });
          });
      });
    },

    fetchJobs() {
      this.loader = true;
      const result = [];
      const where = ((this.$route.params.type && this.$route.params.type.toLowerCase()) || 'job');
      let req = null;

      if(this.$route.query.dir && this.$route.query.dir !== 'all') {
        req = this.fire()
          .collection('works_type')
          .where(`dir`, '==', this.$route.query.dir);
      } else {
        req = this.fire()
          .collection('works_type')
          .where('type', 'in', [where, where.toUpperCase()])
      }
      req.get()
        .then((data) => {
          data.forEach((subDoc) => {
            const data = subDoc.data();
            if(this.$route.query.dir !== 'all') {
              result.push({
                id: subDoc.id,
                name: data.name || data.id || '',
                type: this.$route.params.type,
                _data: data,
              });
            } else {
              if(!data.dir) {
                result.push({
                  id: subDoc.id,
                  name: data.name || data.id || '',
                  type: this.$route.params.type,
                  _data: data,
                });
              }
            }
          });
        })
        .finally(() => {
          this.works = _.orderBy(result, '_data.index', ['asc']);
          this.loader = false;
        });
    },
  },

  computed: {
    filteredList() {
      return this.works.filter(work => {
        return work.name.toLowerCase().includes(this.search.toLowerCase());
      });
    },
  },
};
</script>

<style scoped lang="scss">
.jobs-list {
  max-width: 382px;
  width: calc(100% - 40px);
  margin: 22px auto;
}

.input-search {
  margin-top: 12px;
}

.jobs-ul {
  display: flex;
  flex-direction: column;
  margin-top: 10px;

  .jobs-li {
    align-items: center;
    height: auto !important;
    display: flex;
    justify-content: space-between;
    min-height: 36px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.18);
    cursor: pointer;
    padding: 4px 12px;

    color: #000;
    text-decoration: none !important;

    span {
      text-align: left;
    }

    &:hover {
      background: #f0f0f0;
    }

    &:last-child {
      border-bottom: none;
    }
  }
}

.notify {
  background: #f0f0f0;
  color: #888;
  font-size: 13px;
  padding: 8px 4px;
  border-radius: 4px;
}

.add-job {
  > > > button {
    width: 100%;
    margin-top: 12px;
  }
}

.fa-edit {
  color: #000;
}

.fa-trash {
  margin-right: 15px;
}

.name {
  display: flex;
  align-items: center;

  i {
    margin-right: 10px;
  }
}

.flex-end {
  display: flex;
  justify-content: flex-end;
}
</style>



// WEBPACK FOOTER //
// src/views/Dashboard/WorkType/Index.vue